/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const TicketStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  request: {
    name: 'แจ้งแก้ไข',
    color: 'info',
    icon: 'task_alt',
  },
  debug: {
    name: 'กำลังแก้ไข',
    color: 'error',
    icon: 'task_alt',
  },
  recheck: {
    name: 'แจ้งตรวจสอบ',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'แก้ไขเสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default TicketStatus;
